import React from "react";
import Svg, { Path } from "react-native-svg";

const WhatsappWhite = (props) => (
  <Svg width={15} height={16} fill="none" {...props}>
    <Path
      d="M7.202.8h-.004C3.228.8 0 4.03 0 8c0 1.576.508 3.036 1.37 4.22l-.897 2.676 2.768-.885a7.138 7.138 0 003.96 1.19c3.97 0 7.199-3.23 7.199-7.2S11.172.8 7.202.8z"
      fill="#fff"
    />
    <Path
      d="M11.38 10.986c-.173.49-.86.897-1.408 1.015-.374.08-.864.144-2.512-.54-2.107-.877-3.465-3.025-3.57-3.164-.102-.14-.852-1.138-.852-2.17s.523-1.535.733-1.75c.173-.178.46-.259.734-.259.088 0 .168.005.24.008.21.01.316.022.455.355.173.419.595 1.45.645 1.557.05.106.102.25.03.39-.067.143-.126.207-.232.33-.106.122-.206.215-.312.346-.097.115-.206.237-.084.448.122.207.543.897 1.163 1.45.801.716 1.45.944 1.682 1.041.173.072.38.055.506-.08.16-.174.359-.461.56-.745.144-.203.325-.228.515-.156.193.067 1.218.575 1.429.68.21.107.35.157.4.246.05.09.05.507-.122.998z"
      fill="#55CD1D"
    />
  </Svg>
);

export default WhatsappWhite;
